import { Base } from "ui/Scripts/source/framework/base";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { IUserGroupIntraModule, UserGroupIntraModule } from "../intraModule/userGroupIntraModule";
import { IUserListItem, UserListItem } from "../user/userListItem";
import { IUserGroupEditItem, UserGroupEditItem } from "./userGroupEditItem";

export interface IUserGroupEdit {
    userGroup: IUserGroupEditItem;
    users: IUserListItem[];
    authorizationLevels: INumberTitle[];
    intraModules: IUserGroupIntraModule[];
}

export class UserGroupEdit implements IUserGroupEdit {
    userGroup: UserGroupEditItem;
    users: UserListItem[];
    authorizationLevels: NumberTitle[];
    intraModules: UserGroupIntraModule[];

    constructor();
    constructor(obj: IUserGroupEdit);
    constructor(obj?: any) {
        this.userGroup = new UserGroupEditItem(obj ? obj.userGroup : null);
        this.users = Base.getTypedArray(obj ? obj.users : null, UserListItem);
        this.authorizationLevels = Base.getTypedArray(obj ? obj.authorizationLevels : null, NumberTitle);
        this.intraModules = Base.getTypedArray(obj ? obj.intraModules : null, UserGroupIntraModule);
    }
}